export const REGIONS = ["EMEA", "APAC", "LATAM", "NORAM"];
export const TRAINING_TYPE = [
  "-",
  "ASSOCIATE",
  "TECHNICAL_SALES",
  "PROFESSIONAL",
  "WEBINAR",
  "HOT"
];
